<template>
  <div class="header" role="banner">
    <router-link to="/" aria-label="Return to Parkspass home page">
      <img
        class="logo"
        src="../assets/icons/New-Utah-Parkspass-Logo.svg"
        alt="Parkspass"
      />
    </router-link>
    <!-- right side info -->
    <div id="right-header">
      <!-- events link -->
      <div id="event-link">
        <a
          href="https://events.parkspass.app/"
          target="_blank"
          rel="noopener noreferrer"
          class="eventsLink"
        >
          Open Park Events
        </a>
        <img src="../assets/icons/open.svg" alt="" />
      </div>

      <!-- help button -->
      <button
        type="button"
        class="helpContainer"
        @click="helpClicked"
        @keydown.enter="helpClicked"
        @keydown.space.prevent="helpClicked"
        aria-label="Open help center in new window"
      >
        <span class="helpText" aria-hidden="true">Help</span>
        <img
          class="helpBtn"
          src="../assets/icons/help.svg"
          alt=""
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    helpClicked() {
      window.open(
        "https://parkspass.zendesk.com/hc/en-us",
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
};
</script>

<style scoped>
.eventsLink {
  color: #cacaca;
  font-family: "korolev", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  line-height: normal;
  text-decoration: none;
  padding-right: 12px;
}
#event-link {
  margin-right: 35px;
  display: flex;
  align-items: center;
}
#right-header {
  display: flex;
  align-items: center;
}
.logo {
  height: 40px;
}

.helpText {
  color: #fff;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0;
  margin-right: 6px;
}

.helpContainer {
  border-radius: 5px;
  background: #727a35;
  display: flex;
  align-items: center;
  padding: 9px 15px;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

/* Clear focus styles for keyboard navigation */
.helpContainer:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 2px;
}

.helpContainer:hover {
  background: #5f6430;
}

/* Focus style for logo link */
.header a:focus-visible {
  outline: 3px solid #727a35;
  outline-offset: 4px;
  border-radius: 4px;
}

.header {
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media only screen and (max-width: 425px) {
  .logo {
    height: 32px;
  }
  .header {
    padding: 0 1rem;
  }
  .helpText {
    font-size: 14px;
  }
  .helpContainer > img {
    height: 20px;
  }
  #event-link {
    display: none;
  }
}

@media only screen and (max-width: 360px) {
  .logo {
    height: 24px;
  }
}
</style>
